import { render, staticRenderFns } from "./UsersEditor.vue?vue&type=template&id=6cdc7d2c&scoped=true&"
import script from "./UsersEditor.vue?vue&type=script&lang=js&"
export * from "./UsersEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc7d2c",
  null
  
)

export default component.exports